<template>
  <div class="sidebar-logo-container">
    <router-link class="sidebar-logo-link" to="/">
      <h1 class="sidebar-title">福鼎市零工市场</h1>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'SidebarLogo'
}
</script>
